import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Main } from '../core/main.service';

@Injectable({
    providedIn: 'root'
})
export class AdService {
    constructor(private httpClient: HttpClient, private mainService: Main, @Inject(Restangular) public Restangular: any) {
    }

    getAds(page: number, options: string) {
        debugger;
        return this.Restangular.one('advs?page=' + page + options).customGET('');
    }

    getAllAds(options: string = null) {
        debugger;
        return this.Restangular.one('advs?all=true' + options).customGET('');
    }

    getClientAds(id: String) {
        debugger;
        return this.Restangular.one('client/' + id + '/ads').customGET('');
    }

    getAd(id: string) {
        return this.Restangular.one('ads/' + id).customGET('');
    }

    createAd(ad: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('advs/' + id).customPUT(ad);
        }
        return this.Restangular.one('advs').customPOST(ad);
    }

    changeAdStatus(id: string, status: string) {
        return this.Restangular.one(`advs/${id}/${status}`).customPUT();
    }

    getClients(page: number, options: string) {
        debugger;
        return this.Restangular.one('clients?page=' + page + options).customGET('');
    }

    getAllClients(options: string = null) {
        debugger;
        return this.Restangular.one('clients' + options).customGET('');
    }


    getClient(id: string) {
        return this.Restangular.one('clients/' + id).customGET('');
    }

    createClient(ad: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('clients/' + id).customPUT(ad);
        }
        return this.Restangular.one('clients').customPOST(ad);
    }

    changeClientStatus(id: string, status: string) {
        return this.Restangular.one(`clients/${id}/${status}`).customPUT('');
    }

}
